import {apiService} from '../apiService';

export const lookupsService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getDietaryNeedOptions: builder.query({
                query: () => ({
                    url: '/lookup/special-dietary-needs'
                })
            }),
            // With a child's id, a question the school has turned off or removed still comes back
            // when that child holds it.
            getWelfareOptions: builder.query({
                query: (studentId) => ({
                    url: '/lookup/welfare',
                    params: studentId ? {studentId} : undefined
                }),
                providesTags: (_) => ['WelfareOptions']
            }),
            getWelfareSettings: builder.query({
                query: () => ({
                    url: '/lookup/welfare/settings'
                }),
                providesTags: (_) => ['WelfareOptions']
            }),
            manageWelfareOptions: builder.mutation({
                query: (body) => ({
                    url: '/lookup/welfare',
                    method: 'POST',
                    data: body,
                }),
                invalidatesTags: ['WelfareOptions']
            }),
            getMedicalConsentOptions: builder.query({
                query: () => ({
                    url: '/lookup/medical-consents'
                }),
                providesTags: (_) => ['MedicalConsents']
            }),
            manageMedicalConsents: builder.mutation({
                query: (body) => ({
                    url: '/lookup/medical-consents',
                    method: 'POST',
                    data: body,
                }),
                invalidatesTags: ['MedicalConsents']
            }),
            getAdmissionCategories: builder.query({
                query: () => ({
                    url: '/lookup/admission-categories'
                }),
                providesTags: (_) => ['AdmissionCategories']
            }),
            manageAdmissionCategories: builder.mutation({
                query: (body) => ({
                    url: '/lookup/admission-categories',
                    method: 'POST',
                    data: body,
                }),
                invalidatesTags: ['AdmissionCategories', 'GroupFilters']
            }),
            getTravelOptions: builder.query({
                query: () => ({
                    url: '/lookup/travels'
                }),
            }),
            getMedicalEventTypes: builder.query({
                query: () => ({
                    url: '/lookup/medical-events'
                }),
            }),
            getContactTitles: builder.query({
                query: () => ({
                    url: '/lookup/titles'
                }),
            }),
            getConsentLookups: builder.query({
                query: () => ({
                    url: '/lookup/consents'
                }),
                providesTags: (_) => ['ConsentLookups']
            }),
            getSchools: builder.query({
                query: () => ({
                    url: '/lookup/schools'
                }),
            }),
            getGenders: builder.query({
                query: () => ({
                    url: '/lookup/genders'
                }),
            }),
            getRelationships: builder.query({
                query: () => ({
                    url: '/lookup/relationships'
                }),
            }),
            getBoarderStatuses: builder.query({
                query: () => ({
                    url: '/lookup/boarder-statuses'
                }),
            }),
            getRelations: builder.query({
                query: () => ({
                    url: '/lookup/relations'
                }),
            }),
            getCountries: builder.query({
                query: () => ({
                    url: '/country/list'
                }),
            }),
            getUkCountries: builder.query({
                query: () => ({
                    url: '/lookup/uk-countries'
                }),
                transformResponse: (response) => response?.options ?? [],
            }),
            getReligions: builder.query({
                query: () => ({
                    url: '/lookup/religions',
                    method: 'GET',
                }),
                providesTags: ['Religions'],
            }),
            GetNextOfKinTypes: builder.query({
                query: () => ({
                    url: '/lookup/next-of-kin-types'
                }),
            }),
            GetEmployeeContactTypes: builder.query({
                query: () => ({
                    url: '/lookup/employee-contact-types'
                }),
            }),
        }),
});

export const {
    useGetDietaryNeedOptionsQuery,
    useGetWelfareOptionsQuery,
    useGetWelfareSettingsQuery,
    useManageWelfareOptionsMutation,
    useGetMedicalConsentOptionsQuery,
    useManageMedicalConsentsMutation,
    useGetAdmissionCategoriesQuery,
    useManageAdmissionCategoriesMutation,
    useGetTravelOptionsQuery,
    useGetMedicalEventTypesQuery,
    useGetContactTitlesQuery,
    useGetConsentLookupsQuery,
    useGetGendersQuery,
    useGetRelationshipsQuery,
    useGetBoarderStatusesQuery,
    useGetSchoolsQuery,
    useGetRelationsQuery,
    useGetCountriesQuery,
    useGetUkCountriesQuery,
    useGetReligionsQuery,
    useGetNextOfKinTypesQuery,
    useGetEmployeeContactTypesQuery
} = lookupsService;
